(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueJLunarDatePicker"] = factory();
	else
		root["VueJLunarDatePicker"] = factory();
})(this, function() {
return webpackJsonpVueJLunarDatePicker([1],{

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_13_0_4_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_31297f8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_13_0_4_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(120);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_13_0_4_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_31297f8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_13_0_4_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_13_0_4_vue_loader_lib_selector_type_script_index_0_JDatePicker_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_428f3da2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_13_0_4_vue_loader_lib_selector_type_template_index_0_JDatePicker_vue__ = __webpack_require__(121);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_13_0_4_vue_loader_lib_selector_type_script_index_0_JDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_428f3da2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_13_0_4_vue_loader_lib_selector_type_template_index_0_JDatePicker_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('label', {
    staticClass: "tt"
  }, [_vm._v("请选择日期: ")]), _vm._v(" "), _c('j-date-picker', {
    attrs: {
      "width": _vm.width1,
      "placeholder": _vm.placeholder,
      "picker-options": _vm.pickerOptions,
      "rangeSeparator": _vm.rangeSeparator,
      "disabled": _vm.disabled,
      "showLunarClass": _vm.showLunarClass,
      "showLunarControl": _vm.showLunarControl,
      "type": _vm.type,
      "showBackYears": _vm.showBackYears,
      "showLunarIcon": _vm.showLunarIcon,
      "format": _vm.format
    },
    on: {
      "change": _vm.onDateChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tt",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("选择的日期是：" + _vm._s(_vm.value1))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("返回结果：公历：2017-01-01；农历：L2017-01-01；农历闰月：LR2017-06-01; 日期段(公历)：['2017-01-02','2017.02.01'];日期段(农历)：['L2017-01-02','L2017.02.01'];")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "点击提交查看结果"
    },
    on: {
      "click": _vm.onBtnClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "param"
  }, [_c('h4', [_vm._v("设置后需要重新选择日期才能看见更新效果")]), _vm._v(" "), _c('label', [_vm._v("宽度：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.width1),
      expression: "width1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.width1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.width1 = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("文本占位：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.placeholder),
      expression: "placeholder"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.placeholder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.placeholder = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("选择范围时的分隔符：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rangeSeparator),
      expression: "rangeSeparator"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rangeSeparator)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rangeSeparator = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("类型：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DATE"
    }
  }, [_vm._v("DATE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DATERANGE"
    }
  }, [_vm._v("DATERANGE")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("农历显示样式：")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLunarClass),
      expression: "showLunarClass"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showLunarClass = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FULLLUNAR"
    }
  }, [_vm._v("FULLLUNAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LUNAR"
    }
  }, [_vm._v("LUNAR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NUMBER"
    }
  }, [_vm._v("NUMBER")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MIX"
    }
  }, [_vm._v("MIX")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("是否显示农历控制组件：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLunarControl),
      expression: "showLunarControl"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showLunarControl) ? _vm._i(_vm.showLunarControl, null) > -1 : (_vm.showLunarControl)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.showLunarControl,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showLunarControl = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showLunarControl = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showLunarControl = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("是否显示农历标记：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showLunarIcon),
      expression: "showLunarIcon"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showLunarIcon) ? _vm._i(_vm.showLunarIcon, null) > -1 : (_vm.showLunarIcon)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.showLunarIcon,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showLunarIcon = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showLunarIcon = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showLunarIcon = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("禁用：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.disabled) ? _vm._i(_vm.disabled, null) > -1 : (_vm.disabled)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.disabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.disabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.disabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disabled = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("文本框可输入：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editable),
      expression: "editable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editable) ? _vm._i(_vm.editable, null) > -1 : (_vm.editable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.editable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.editable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.editable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.editable = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("是否显示清除按钮：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearable),
      expression: "clearable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearable) ? _vm._i(_vm.clearable, null) > -1 : (_vm.clearable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.clearable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.clearable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.clearable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.clearable = $$c
        }
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("向后显示年数：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showBackYears),
      expression: "showBackYears"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.showBackYears)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.showBackYears = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', [_vm._v("格式化：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.format),
      expression: "format"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.format)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.format = $event.target.value
      }
    }
  }), _vm._v(" (不区分大小写)"), _c('br')]), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api"
  }, [_c('h3', [_vm._v("使用说明")]), _vm._v(" "), _c('p', [_vm._v("引入组件并注册：")]), _vm._v(" "), _c('p', [_vm._v("Script:")]), _vm._v(" "), _c('p', {
    staticClass: "js"
  }, [_vm._v("\n      import JDatePicker from '@/components/JDatePicker.vue'\n      "), _c('br'), _vm._v("\n      export default{"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "10px"
    }
  }), _vm._v("components:{ JDatePicker },"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "20px"
    }
  }), _vm._v("data:{"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "30px"
    }
  }), _vm._v("return{"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "40px"
    }
  }), _vm._v("pickerOptions: {"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "50px"
    }
  }), _vm._v("disabledDate (time) {"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "60px"
    }
  }), _vm._v("return time.getTime() < Date.now() - 8.64e7;"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "50px"
    }
  }), _vm._v("}"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "40px"
    }
  }), _vm._v("}"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "30px"
    }
  }), _vm._v("}"), _c('br'), _vm._v(" "), _c('i', {
    staticStyle: {
      "padding-left": "20px"
    }
  }), _vm._v("}"), _c('br'), _vm._v("\n      }\n    ")]), _vm._v(" "), _c('p', [_vm._v("HTML:")]), _vm._v(" "), _c('p', {
    staticClass: "js"
  }, [_vm._v("\n     < j-date-picker v-model=\"value1\" width=\"300\" show-lunar-class=\"fulllunar\" :picker-options=\"pickerOptions\" :show-back-years=\"5\" :show-lunar-control='showLunarControl' show-lunar-icon format=\"yyyy.mm.dd\">< /j-date-picker>\n    ")]), _vm._v(" "), _c('h3', [_vm._v("参数：")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("绑定值(v-model);"), _c('br'), _vm._v("时间段模式为字符串数组")]), _vm._v(" "), _c('td', [_vm._v("String,Date,Array")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("类型")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("DATE(日期)"), _c('br'), _vm._v("DATETANGE(时间段)")]), _vm._v(" "), _c('td', [_vm._v("DATE")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("editable")]), _vm._v(" "), _c('td', [_vm._v("文本框可输入;农历模式且展示类型为非'NUMBER'时,为false")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("clearable")]), _vm._v(" "), _c('td', [_vm._v("是否显示清除按钮")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("禁用")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("宽度")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("200px/200")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("占位内容")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" - ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-lunar-class")]), _vm._v(" "), _c('td', [_vm._v("农历日期的展示类型")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("\n          FULLLUNAR(全农历)"), _c('br'), _vm._v("LUNAR(农历)"), _c('br'), _vm._v("NUMBER(数字)"), _c('br'), _vm._v("MIX(混合)"), _c('br')]), _vm._v(" "), _c('td', [_vm._v("NUMBER")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-lunar-icon")]), _vm._v(" "), _c('td', [_vm._v("是否显示农历标记")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-back-years")]), _vm._v(" "), _c('td', [_vm._v("向后展示年数;"), _c('br'), _vm._v("见于年份列表;"), _c('br'), _vm._v("时间段模式无效")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("－")]), _vm._v(" "), _c('td', [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("format")]), _vm._v(" "), _c('td', [_vm._v("时间日期格式化")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("年：YYYY ，月：MM ，日：DD ，时：HH  ，分：MM ，秒：SS")]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-lunar-control")]), _vm._v(" "), _c('td', [_vm._v("是否显示农历控制组件")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("true"), _c('br'), _vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("true")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("range-separator")]), _vm._v(" "), _c('td', [_vm._v("选择范围时的分隔符")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" '-' ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("picker-options")]), _vm._v(" "), _c('td', [_vm._v("参考下表")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" {} ")])])]), _vm._v(" "), _c('h3', [_vm._v("picker-options：")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabledDate")]), _vm._v(" "), _c('td', [_vm._v("设置禁用状态，参数为当前日期，要求返回 Boolean")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])])]), _vm._v(" "), _c('h3', [_vm._v("事件：")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("当input值发生改变时，返回值与文本框一致")]), _vm._v(" "), _c('td', [_vm._v("格式化后的值")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-jcalendar",
    style: ({
      width: _vm.handleWidth + 'px'
    })
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLunar && _vm.showLunarIcon),
      expression: "isLunar && showLunarIcon"
    }],
    staticClass: "input-icon__tip"
  }, [(_vm.isLeap) ? _c('i', [_vm._v("闰")]) : _c('i', [_vm._v("农")])]), _vm._v(" "), _c('p', {
    staticClass: "input-icon",
    on: {
      "mouseover": _vm.onInputOver,
      "mouseout": _vm.onInputOut
    }
  }, [_c('i', {
    staticClass: "iconfont icon-time",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.clearVisible),
      expression: "!clearVisible"
    }],
    staticClass: "iconfont icon-richeng"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clearable && _vm.clearVisible),
      expression: "clearable && clearVisible"
    }],
    staticClass: "iconfont icon-guanbi is-clear",
    on: {
      "click": _vm.onClearInput
    }
  })]), _vm._v(" "), _c('input', {
    class: ['input__inner', {
      'is-disabled': _vm.disabled
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "readonly": !_vm.editable || _vm.type.toUpperCase() === 'DATERANGE' || (_vm.isLunar && _vm.showLunarClass.toUpperCase() != 'NUMBER'),
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.inputText
    },
    on: {
      "click": _vm.onInputFocus,
      "input": function($event) {
        _vm.inputText = $event.target.value
      },
      "change": _vm.handleInputChange
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calendarVisible),
      expression: "calendarVisible"
    }],
    staticClass: "full-jcalendar__main",
    class: {
      'is-daterange': _vm.type.toUpperCase() === 'DATERANGE'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type.toUpperCase() === 'DATE'),
      expression: "type.toUpperCase() === 'DATE'"
    }]
  }, [_c('div', {
    staticClass: "full-jcalendar-header"
  }, [_c('span', {
    staticClass: "title-year",
    on: {
      "click": _vm.showYearList
    }
  }, [_vm._v(_vm._s(_vm.year) + "年")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-month",
    on: {
      "click": function($event) {
        _vm.monthVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.month) + "月")]), _vm._v(" "), (_vm.showLunarControl) ? _c('span', {
    staticStyle: {
      "width": "10px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLunarControl) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isLunar),
      expression: "isLunar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isLunar) ? _vm._i(_vm.isLunar, null) > -1 : (_vm.isLunar)
    },
    on: {
      "change": _vm.onLunarChange,
      "__c": function($event) {
        var $$a = _vm.isLunar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isLunar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isLunar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isLunar = $$c
        }
      }
    }
  }), _vm._v("农历")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "prev-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goPrev($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangzuojiantou"
  })]), _vm._v(" "), _c('p', {
    staticClass: "next-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goNext($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangyoujiantou"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "full-jcalendar__body"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.calendarDatas), function(week) {
    return _c('div', {
      staticClass: "week-row"
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "day-cell",
        class: [{
          'today': day.isToday,
          'not-optional': _vm.isNotOptional(day),
          'select': day.isSelect,
          'not-cur-month': !day.isCurMonth
        }],
        on: {
          "click": function($event) {
            _vm.onDateSelect(day)
          }
        }
      }, [_c('div', {
        staticClass: "day-number"
      }, [_c('p', {
        staticClass: "solar"
      }, [(day.lDate.isLeap && day.lDate.IDayCn === '初一') ? _c('span', {
        staticClass: "is-leap"
      }, [_vm._v("闰")]) : _vm._e(), _vm._v(" "), _c('span', {
        class: ['number', {
          'is-today': day.isToday,
          'is-empty': day.isToday && !day.lDate.isFestival && !day.lDate.isTerm
        }]
      }, [_vm._v(_vm._s(day.isToday ? '今天' : day.day))])]), _vm._v(" "), _c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!day.isToday || day.lDate.isFestival || day.lDate.isTerm),
          expression: "!day.isToday || day.lDate.isFestival || day.lDate.isTerm"
        }],
        staticClass: "lunar"
      }, [(day.lDate.isFestival) ? _c('span', {
        staticClass: "festival"
      }, [_vm._v(_vm._s(day.lDate.festival[0]))]) : (day.lDate.isTerm) ? _c('span', {
        staticClass: "term"
      }, [_vm._v(_vm._s(day.lDate.Term))]) : (day.lDate.IDayCn === '初一') ? _c('span', [_vm._v(_vm._s(day.lDate.IMonthCn.replace('闰', '')))]) : _c('span', [_vm._v(_vm._s(day.lDate.IDayCn))])])])])
    }))
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monthVisible),
      expression: "monthVisible"
    }],
    staticClass: "full-jcalendar__month"
  }, [_c('div', {
    staticClass: "full-jcalendar-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.month) + "月")])]), _vm._v(" "), _c('div', {
    staticClass: "full-jcalendar__body"
  }, [_c('ul', {
    staticClass: "data-list"
  }, _vm._l((12), function(m) {
    return _c('li', {
      key: m,
      on: {
        "click": function($event) {
          _vm.onMonthSelect(m - 1)
        }
      }
    }, [_vm._v(_vm._s(m) + "月")])
  })), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.monthVisible = false
      }
    }
  }, [_vm._v("取 消")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.yearVisible),
      expression: "yearVisible"
    }],
    staticClass: "full-jcalendar__year"
  }, [_c('div', {
    staticClass: "full-jcalendar-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.year) + "年")]), _vm._v(" "), _c('p', {
    staticClass: "prev-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goYearPrevList($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangzuojiantou"
  })]), _vm._v(" "), _c('p', {
    staticClass: "next-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goYearNextList($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangyoujiantou"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "full-jcalendar__body"
  }, [_c('ul', {
    staticClass: "data-list"
  }, _vm._l((12), function(m) {
    return _c('li', {
      key: m,
      class: {
        'select-year': (m + _vm.startYear - 1) == _vm.year, 'curr-year': (m + _vm.startYear - 1) == _vm.todayYear
      },
      on: {
        "click": function($event) {
          _vm.onYearSelect(m + _vm.startYear - 1)
        }
      }
    }, [_vm._v(_vm._s(m + _vm.startYear - 1))])
  })), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.yearVisible = false
      }
    }
  }, [_vm._v("取 消")])])])]), _vm._v(" "), (_vm.type.toUpperCase() === 'DATERANGE') ? _c('div', {
    staticClass: "date-range__month leftMonth"
  }, [_c('div', {
    staticClass: "full-jcalendar-header"
  }, [_c('span', {
    staticClass: "title-year"
  }, [_vm._v(_vm._s(_vm.year) + "年")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-month"
  }, [_vm._v(_vm._s(_vm.month) + "月")]), _vm._v(" "), (_vm.showLunarControl) ? _c('span', {
    staticStyle: {
      "width": "10px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLunarControl) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isLunar),
      expression: "isLunar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isLunar) ? _vm._i(_vm.isLunar, null) > -1 : (_vm.isLunar)
    },
    on: {
      "change": _vm.onLunarChange,
      "__c": function($event) {
        var $$a = _vm.isLunar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isLunar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isLunar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isLunar = $$c
        }
      }
    }
  }), _vm._v("农历")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "prev-year",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goYearPrev($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangzuojiantou"
  })]), _vm._v(" "), _c('p', {
    staticClass: "prev-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goPrev($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangzuojiantou"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "full-jcalendar__body"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.calendarDatas), function(week) {
    return _c('div', {
      staticClass: "week-row",
      on: {
        "mouseout": _vm.onMouseOut
      }
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "day-cell",
        class: [{
          'today': day.isToday,
          'not-optional': _vm.isNotOptional(day),
          'choose': _vm.isChoose(day),
          'select': _vm.isSelect(day),
          'not-cur-month': !day.isCurMonth
        }],
        on: {
          "click": function($event) {
            _vm.onDateSelect(day)
          },
          "mouseover": function($event) {
            _vm.onMouseOver(day)
          }
        }
      }, [_c('div', {
        staticClass: "day-number"
      }, [_c('p', {
        staticClass: "solar"
      }, [(day.lDate.isLeap && day.lDate.IDayCn === '初一') ? _c('span', {
        staticClass: "is-leap"
      }, [_vm._v("闰")]) : _vm._e(), _vm._v(" "), _c('span', {
        class: ['number', {
          'is-today': day.isToday,
          'is-empty': day.isToday && !day.lDate.isFestival && !day.lDate.isTerm
        }]
      }, [_vm._v(_vm._s(day.isToday ? '今天' : day.day))])]), _vm._v(" "), _c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!day.isToday || day.lDate.isFestival || day.lDate.isTerm),
          expression: "!day.isToday || day.lDate.isFestival || day.lDate.isTerm"
        }],
        staticClass: "lunar"
      }, [(day.lDate.isFestival) ? _c('span', {
        staticClass: "festival"
      }, [_vm._v(_vm._s(day.lDate.festival[0]))]) : (day.lDate.isTerm) ? _c('span', {
        staticClass: "term"
      }, [_vm._v(_vm._s(day.lDate.Term))]) : (day.lDate.IDayCn === '初一') ? _c('span', [_vm._v(_vm._s(day.lDate.IMonthCn.replace('闰', '')))]) : _c('span', [_vm._v(_vm._s(day.lDate.IDayCn))])])])])
    }))
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.type.toUpperCase() === 'DATERANGE') ? _c('div', {
    staticClass: "date-range__month"
  }, [_c('div', {
    staticClass: "full-jcalendar-header"
  }, [_c('span', {
    staticClass: "title-year"
  }, [_vm._v(_vm._s(_vm.year2) + "年")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-month"
  }, [_vm._v(_vm._s(_vm.month2) + "月")]), _vm._v(" "), _c('p', {
    staticClass: "next-year",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goYearNext($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangyoujiantou"
  })]), _vm._v(" "), _c('p', {
    staticClass: "next-month",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goNext($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-xiangyoujiantou"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "full-jcalendar__body"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.calendarDatas2), function(week) {
    return _c('div', {
      staticClass: "week-row",
      on: {
        "mouseout": _vm.onMouseOut
      }
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "day-cell",
        class: [{
          'today': day.isToday,
          'not-optional': _vm.isNotOptional(day),
          'choose': _vm.isChoose(day),
          'select': _vm.isSelect(day),
          'not-cur-month': !day.isCurMonth
        }],
        on: {
          "click": function($event) {
            _vm.onDateSelect(day)
          },
          "mouseover": function($event) {
            _vm.onMouseOver(day);
          }
        }
      }, [_c('div', {
        staticClass: "day-number"
      }, [_c('p', {
        staticClass: "solar"
      }, [(day.lDate.isLeap && day.lDate.IDayCn === '初一') ? _c('span', {
        staticClass: "is-leap"
      }, [_vm._v("闰")]) : _vm._e(), _vm._v(" "), _c('span', {
        class: ['number', {
          'is-today': day.isToday,
          'is-empty': day.isToday && !day.lDate.isFestival && !day.lDate.isTerm
        }]
      }, [_vm._v(_vm._s(day.isToday ? '今天' : day.day))])]), _vm._v(" "), _c('p', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!day.isToday || day.lDate.isFestival || day.lDate.isTerm),
          expression: "!day.isToday || day.lDate.isFestival || day.lDate.isTerm"
        }],
        staticClass: "lunar"
      }, [(day.lDate.isFestival) ? _c('span', {
        staticClass: "festival"
      }, [_vm._v(_vm._s(day.lDate.festival[0]))]) : (day.lDate.isTerm) ? _c('span', {
        staticClass: "term"
      }, [_vm._v(_vm._s(day.lDate.Term))]) : (day.lDate.IDayCn === '初一') ? _c('span', [_vm._v(_vm._s(day.lDate.IMonthCn.replace('闰', '')))]) : _c('span', [_vm._v(_vm._s(day.lDate.IDayCn))])])])])
    }))
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weeks"
  }, [_c('strong', {
    staticClass: "week"
  }, [_vm._v("日")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("一")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("二")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("三")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("四")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("五")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("六")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weeks"
  }, [_c('strong', {
    staticClass: "week"
  }, [_vm._v("日")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("一")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("二")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("三")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("四")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("五")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("六")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weeks"
  }, [_c('strong', {
    staticClass: "week"
  }, [_vm._v("日")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("一")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("二")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("三")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("四")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("五")]), _vm._v(" "), _c('strong', {
    staticClass: "week"
  }, [_vm._v("六")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 2,
	"./af.js": 2,
	"./ar": 9,
	"./ar-dz": 3,
	"./ar-dz.js": 3,
	"./ar-kw": 4,
	"./ar-kw.js": 4,
	"./ar-ly": 5,
	"./ar-ly.js": 5,
	"./ar-ma": 6,
	"./ar-ma.js": 6,
	"./ar-sa": 7,
	"./ar-sa.js": 7,
	"./ar-tn": 8,
	"./ar-tn.js": 8,
	"./ar.js": 9,
	"./az": 10,
	"./az.js": 10,
	"./be": 11,
	"./be.js": 11,
	"./bg": 12,
	"./bg.js": 12,
	"./bn": 13,
	"./bn.js": 13,
	"./bo": 14,
	"./bo.js": 14,
	"./br": 15,
	"./br.js": 15,
	"./bs": 16,
	"./bs.js": 16,
	"./ca": 17,
	"./ca.js": 17,
	"./cs": 18,
	"./cs.js": 18,
	"./cv": 19,
	"./cv.js": 19,
	"./cy": 20,
	"./cy.js": 20,
	"./da": 21,
	"./da.js": 21,
	"./de": 24,
	"./de-at": 22,
	"./de-at.js": 22,
	"./de-ch": 23,
	"./de-ch.js": 23,
	"./de.js": 24,
	"./dv": 25,
	"./dv.js": 25,
	"./el": 26,
	"./el.js": 26,
	"./en-au": 27,
	"./en-au.js": 27,
	"./en-ca": 28,
	"./en-ca.js": 28,
	"./en-gb": 29,
	"./en-gb.js": 29,
	"./en-ie": 30,
	"./en-ie.js": 30,
	"./en-nz": 31,
	"./en-nz.js": 31,
	"./eo": 32,
	"./eo.js": 32,
	"./es": 34,
	"./es-do": 33,
	"./es-do.js": 33,
	"./es.js": 34,
	"./et": 35,
	"./et.js": 35,
	"./eu": 36,
	"./eu.js": 36,
	"./fa": 37,
	"./fa.js": 37,
	"./fi": 38,
	"./fi.js": 38,
	"./fo": 39,
	"./fo.js": 39,
	"./fr": 42,
	"./fr-ca": 40,
	"./fr-ca.js": 40,
	"./fr-ch": 41,
	"./fr-ch.js": 41,
	"./fr.js": 42,
	"./fy": 43,
	"./fy.js": 43,
	"./gd": 44,
	"./gd.js": 44,
	"./gl": 45,
	"./gl.js": 45,
	"./gom-latn": 46,
	"./gom-latn.js": 46,
	"./he": 47,
	"./he.js": 47,
	"./hi": 48,
	"./hi.js": 48,
	"./hr": 49,
	"./hr.js": 49,
	"./hu": 50,
	"./hu.js": 50,
	"./hy-am": 51,
	"./hy-am.js": 51,
	"./id": 52,
	"./id.js": 52,
	"./is": 53,
	"./is.js": 53,
	"./it": 54,
	"./it.js": 54,
	"./ja": 55,
	"./ja.js": 55,
	"./jv": 56,
	"./jv.js": 56,
	"./ka": 57,
	"./ka.js": 57,
	"./kk": 58,
	"./kk.js": 58,
	"./km": 59,
	"./km.js": 59,
	"./kn": 60,
	"./kn.js": 60,
	"./ko": 61,
	"./ko.js": 61,
	"./ky": 62,
	"./ky.js": 62,
	"./lb": 63,
	"./lb.js": 63,
	"./lo": 64,
	"./lo.js": 64,
	"./lt": 65,
	"./lt.js": 65,
	"./lv": 66,
	"./lv.js": 66,
	"./me": 67,
	"./me.js": 67,
	"./mi": 68,
	"./mi.js": 68,
	"./mk": 69,
	"./mk.js": 69,
	"./ml": 70,
	"./ml.js": 70,
	"./mr": 71,
	"./mr.js": 71,
	"./ms": 73,
	"./ms-my": 72,
	"./ms-my.js": 72,
	"./ms.js": 73,
	"./my": 74,
	"./my.js": 74,
	"./nb": 75,
	"./nb.js": 75,
	"./ne": 76,
	"./ne.js": 76,
	"./nl": 78,
	"./nl-be": 77,
	"./nl-be.js": 77,
	"./nl.js": 78,
	"./nn": 79,
	"./nn.js": 79,
	"./pa-in": 80,
	"./pa-in.js": 80,
	"./pl": 81,
	"./pl.js": 81,
	"./pt": 83,
	"./pt-br": 82,
	"./pt-br.js": 82,
	"./pt.js": 83,
	"./ro": 84,
	"./ro.js": 84,
	"./ru": 85,
	"./ru.js": 85,
	"./sd": 86,
	"./sd.js": 86,
	"./se": 87,
	"./se.js": 87,
	"./si": 88,
	"./si.js": 88,
	"./sk": 89,
	"./sk.js": 89,
	"./sl": 90,
	"./sl.js": 90,
	"./sq": 91,
	"./sq.js": 91,
	"./sr": 93,
	"./sr-cyrl": 92,
	"./sr-cyrl.js": 92,
	"./sr.js": 93,
	"./ss": 94,
	"./ss.js": 94,
	"./sv": 95,
	"./sv.js": 95,
	"./sw": 96,
	"./sw.js": 96,
	"./ta": 97,
	"./ta.js": 97,
	"./te": 98,
	"./te.js": 98,
	"./tet": 99,
	"./tet.js": 99,
	"./th": 100,
	"./th.js": 100,
	"./tl-ph": 101,
	"./tl-ph.js": 101,
	"./tlh": 102,
	"./tlh.js": 102,
	"./tr": 103,
	"./tr.js": 103,
	"./tzl": 104,
	"./tzl.js": 104,
	"./tzm": 106,
	"./tzm-latn": 105,
	"./tzm-latn.js": 105,
	"./tzm.js": 106,
	"./uk": 107,
	"./uk.js": 107,
	"./ur": 108,
	"./ur.js": 108,
	"./uz": 110,
	"./uz-latn": 109,
	"./uz-latn.js": 109,
	"./uz.js": 110,
	"./vi": 111,
	"./vi.js": 111,
	"./x-pseudo": 112,
	"./x-pseudo.js": 112,
	"./yo": 113,
	"./yo.js": 113,
	"./zh-cn": 114,
	"./zh-cn.js": 114,
	"./zh-hk": 115,
	"./zh-hk.js": 115,
	"./zh-tw": 116,
	"./zh-tw.js": 116
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_JDatePicker_vue__ = __webpack_require__(119);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { JDatePicker: __WEBPACK_IMPORTED_MODULE_0__components_JDatePicker_vue__["a" /* default */] },
  data: function data() {
    return {
      value1: new Date(),
      type: 'DATE',
      showLunarClass: 'NUMBER',
      showBackYears: 2,
      showLunarIcon: true,
      showLunarControl: true,
      width1: '600',
      format: 'YYYY.MM.DD',
      placeholder: '请输入内容',
      rangeSeparator: '-',
      disabled: false,
      editable: true,
      clearable: true,
      pickerOptions: {
        //          disabledDate (time) {
        //            return time.getTime() < Date.now() - 8.64e7;
        //          }
      }
    };
  },

  methods: {
    onDateChange: function onDateChange(e) {
      console.log('change=>', e, 'value:', this.value1);
    },
    onBtnClick: function onBtnClick() {
      alert(this.value1);
    }
  },
  created: function created() {
    //        this.value1 = [new Date(),new Date()];
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme_public_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme_public_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__theme_public_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__ = __webpack_require__(130);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: String,
      default: '200'
    },
    value: {
      type: [String, Date, Array],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    showLunarClass: {
      type: String,
      default: 'NUMBER' //共四种，FULLLUNAR－全农历格式：丁酉[鸡]年己酉月乙巳日；LUNAR－中文格式：丁酉[鸡]年七月廿三；NUMBER－数字格式：2017-09-13；MIX格式：丁酉(2017)[鸡]年七月廿三；
    },
    showLunarIcon: {
      type: Boolean,
      default: false
    },
    showBackYears: {
      type: Number,
      default: 2
    },
    showLunarControl: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "DATE" //DATE - 日期类型；DATERANGE － 时间段；
    },
    rangeSeparator: {
      type: String,
      default: "-" //时间段分隔符
    },
    pickerOptions: {
      type: Object,
      default: null
    }
  },
  computed: {
    handleWidth: function handleWidth() {
      var w = this.width.toString();
      if (w == null || w == '') {
        return 200;
      }
      if (w.indexOf('px') > -1) w = w.replace(/px/, '');
      var w0 = parseInt(w) || 0;
      if (w0 == 0) {
        return 200;
      }
      return w0;
    }
  },
  watch: {
    'value': function value(newValue, oldValue) {
      this.inputText = '';
      this.isLeap = false;
      this.isLunar = false;

      this.handleInputText(newValue);
    },
    'showLunarIcon': function showLunarIcon(newValue, oldValue) {}
  },
  data: function data() {
    return {
      inputText: '',
      startYear: 0, //年份列表的起始年份
      monthDay: '', //月份日期类型，用来比较日期
      selectDay: [], //type=daterange,存放点击选中的时间值；
      chooseDay: [], //type=daterange,存放鼠标移动所选时间段；
      year: 0,
      month: 0,
      year2: 0,
      month2: 0,
      isCurrMonth: true,
      calendarDatas: [],
      calendarDatas2: [],
      calendarVisible: false, //日历显示开关
      yearVisible: false, //年份选择开关
      monthVisible: false, //月份选择开关
      clearVisible: false, //清除按钮开关
      isLunar: false, //是否启用农历
      isLeap: false //是否闰月
    };
  },
  created: function created() {
    var _this = this;

    var month = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
    this.monthDay = month.toISOString();
    this.todayYear = month.year();
    this.loadCalendar();

    document.addEventListener('click', function (e) {
      var icon = _this.$el.querySelector('.input-icon');
      var input = _this.$el.querySelector('.input__inner');
      var main = _this.$el.querySelector('.full-jcalendar__main');
      if (!icon.contains(e.target) && !input.contains(e.target) && !main.contains(e.target)) {
        _this.calendarVisible = false;
        if (_this.selectDay.length > 0) {
          _this.monthDay = _this.selectDay[0];
        }
      }
    });

    this.handleInputText(this.value, true);
  },

  methods: {
    handleInputText: function handleInputText(newValue, isNeedEmit) {
      if (newValue == undefined || newValue == null || !newValue.toString().length) return;

      var valueDay = '',
          valueDay2 = '',
          result = '';

      if (this.type.toUpperCase() == 'DATE') {
        //单日期模式
        newValue = newValue.toString();
        var isLunar = newValue.indexOf('L') > -1;
        this.isLunar = isLunar;

        if (isLunar) {
          //农历模式
          var showLunarClass = this.showLunarClass.toUpperCase();
          var lunarDate = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getSolar(newValue);

          valueDay = new Date(lunarDate.cYear + '-' + lunarDate.cMonth + '-' + lunarDate.cDay).toISOString();

          if (showLunarClass == 'NUMBER') {
            result = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(lunarDate.lYear + '-' + lunarDate.lMonth + '-' + lunarDate.lDay)).format(this.format.toUpperCase());
          } else if (showLunarClass == 'MIX') {
            result = lunarDate.gzYear + '(' + lunarDate.lYear + ')[' + lunarDate.Animal + ']年 ' + lunarDate.IMonthCn + lunarDate.IDayCn;
          } else if (showLunarClass == 'FULLLUNAR') {
            result = lunarDate.gzYear + '[' + lunarDate.Animal + ']年 ' + lunarDate.gzMonth + '月 ' + lunarDate.gzDay + '日';
          } else if (showLunarClass == 'LUNAR') {
            result = lunarDate.gzYear + '[' + lunarDate.Animal + ']年 ' + lunarDate.IMonthCn + lunarDate.IDayCn;
          }
        } else {
          //公历模式
          var date = new Date(newValue);
          valueDay = date.toISOString();
          result = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(this.format.toUpperCase());
          this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD'));
        }
        this.monthDay = valueDay;
        this.selectDay = [valueDay];
        this.inputText = result;
        this.loadCalendar();
        return;
      }
      if (this.type.toUpperCase() == 'DATERANGE') {
        //时间段模式
        //判断newValue是否为数组；ES2005以上支持isArray
        if (Array.isArray(newValue) && newValue.length == 2) {
          var beginDt = newValue[0];
          var endDt = newValue[1];
          //判断value是否为日期类型
          if (beginDt == undefined || beginDt == null || !beginDt.toString().length) return;
          if (endDt == undefined || endDt == null || !endDt.toString().length) return;
          beginDt = beginDt.toString();
          endDt = endDt.toString();

          var _isLunar = beginDt.indexOf('L') > -1;
          this.isLunar = _isLunar;
          if (_isLunar) {
            //农历模式
            var beginDateResult = '',
                endDateResult = '';
            var _showLunarClass = this.showLunarClass.toUpperCase();

            var beginLunarDate = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getSolar(beginDt);
            var endLunarDate = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getSolar(endDt);

            valueDay = new Date(beginLunarDate.cYear + '-' + beginLunarDate.cMonth + '-' + beginLunarDate.cDay).toISOString();
            valueDay2 = new Date(endLunarDate.cYear + '-' + endLunarDate.cMonth + '-' + endLunarDate.cDay).toISOString();

            if (_showLunarClass == 'NUMBER') {
              beginDateResult = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(beginLunarDate.lYear + '-' + beginLunarDate.lMonth + '-' + beginLunarDate.lDay)).format(this.format.toUpperCase());
              endDateResult = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(endLunarDate.lYear + '-' + endLunarDate.lMonth + '-' + endLunarDate.lDay)).format(this.format.toUpperCase());
            } else if (_showLunarClass == 'MIX') {
              beginDateResult = beginLunarDate.gzYear + '(' + beginLunarDate.lYear + ')[' + beginLunarDate.Animal + ']年 ' + beginLunarDate.IMonthCn + beginLunarDate.IDayCn;
              endDateResult = endLunarDate.gzYear + '(' + endLunarDate.lYear + ')[' + endLunarDate.Animal + ']年 ' + endLunarDate.IMonthCn + endLunarDate.IDayCn;
            } else if (_showLunarClass == 'FULLLUNAR') {
              beginDateResult = beginLunarDate.gzYear + '[' + beginLunarDate.Animal + ']年 ' + beginLunarDate.gzMonth + '月 ' + beginLunarDate.gzDay + '日';
              endDateResult = endLunarDate.gzYear + '[' + endLunarDate.Animal + ']年 ' + endLunarDate.gzMonth + '月 ' + endLunarDate.gzDay + '日';
            } else if (_showLunarClass == 'LUNAR') {
              beginDateResult = beginLunarDate.gzYear + '[' + beginLunarDate.Animal + ']年 ' + beginLunarDate.IMonthCn + beginLunarDate.IDayCn;
              endDateResult = endLunarDate.gzYear + '[' + endLunarDate.Animal + ']年 ' + endLunarDate.IMonthCn + endLunarDate.IDayCn;
            }

            result = beginDateResult + ' ' + this.rangeSeparator + ' ' + endDateResult;
          } else {
            //公历模式
            if (isNeedEmit) {
              this.$emit('input', [__WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(beginDt)).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(endDt)).format('YYYY-MM-DD')]);
              return;
            }

            var beginDate = new Date(beginDt);
            var endDate = new Date(endDt);
            valueDay = beginDate.toISOString();
            valueDay2 = endDate.toISOString();
            result = __WEBPACK_IMPORTED_MODULE_0_moment___default()(beginDate).format(this.format.toUpperCase()) + ' ' + this.rangeSeparator + ' ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).format(this.format.toUpperCase());
          }
          this.monthDay = valueDay;
          this.selectDay = [valueDay, valueDay2];
          this.chooseDay = [valueDay, valueDay2];
          this.inputText = result;
          this.loadCalendar();
        }
      }
    },
    handleInputChange: function handleInputChange(e) {
      var result = e.target.value;
      if (this.type.toUpperCase() == 'DATE') {
        //单日期
        if (this.isLunar) {
          //农历 NUMBER 模式
          if (this.showLunarClass.toUpperCase() == 'NUMBER') {
            var regex = /\d{4}[-\.\/]\d{1,2}[-\.\/]\d{1,2}/;
            if (!regex.test(result)) return;
            result = result.replace(/\./g, '-').replace(/\//g, '-');
            result = 'L' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(result)).format('YYYY-MM-DD');
          }
        } else {
          var _regex = /\d{4}[-\.\/]\d{1,2}[-\.\/]\d{1,2}/;
          if (!_regex.test(result)) return;
          result = result.replace(/\./g, '-').replace(/\//g, '-');
          result = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(result)).format('YYYY-MM-DD');
        }
      }
      this.$emit('change', result);
      this.$emit('input', result);
    },
    onClearInput: function onClearInput() {
      if (this.type.toUpperCase() == 'DATERANGE') {
        this.$emit('change', []);
        this.$emit('input', []);
      } else {
        this.$emit('change', '');
        this.$emit('input', '');
      }
      this.selectDay = [];
      this.chooseDay = [];
      this.monthDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()().toISOString();
      this.clearVisible = false;
    },
    onInputOver: function onInputOver() {
      if (this.disabled) return;
      if (this.value == null || this.value == '') return;
      this.clearVisible = true;
    },
    onInputOut: function onInputOut() {
      this.clearVisible = false;
    },
    isNotOptional: function isNotOptional(day) {
      if (this.pickerOptions != null && this.pickerOptions != undefined && 'disabledDate' in this.pickerOptions) {
        return this.pickerOptions.disabledDate(new Date(day.date));
      }
      return false;
    },
    isChoose: function isChoose(day) {
      //是否在选中时间段区域内
      if (this.type.toUpperCase() == 'DATERANGE') {
        if (this.chooseDay.length == 2) {
          var currDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day.date);
          return currDay.isSameOrAfter(this.chooseDay[0]) & currDay.isSameOrBefore(this.chooseDay[1]) & day.isCurMonth;
        }
      }
      return false;
    },
    isSelect: function isSelect(day) {
      return this.chooseDay.length > 0 & __WEBPACK_IMPORTED_MODULE_0_moment___default()(day.date).isSame(new Date(this.chooseDay[0]), 'day') & day.isCurMonth;
    },
    onInputFocus: function onInputFocus() {
      if (this.disabled) return;
      this.loadCalendar();
      this.calendarVisible = true;
    },
    onLunarChange: function onLunarChange() {
      if (this.value != null && this.value != '' && this.value.length > 0) {
        if (this.type.toUpperCase() == 'DATERANGE') {
          //时间段模式
          if (this.isLunar) {
            //由公历到农历
            //判断日期结果集中日期格式是否为农历，若是不作处理直接返回。
            if (this.value[0].indexOf('L') > -1) return;
            var beginDay = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getLunar(this.value[0].replace(/L/, '').replace(/R/, ''));
            var endDay = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getLunar(this.value[1].replace(/L/, '').replace(/R/, ''));
            var beginDayResult = 'L' + (beginDay.isLeap ? 'R' : '') + __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(beginDay.lYear + '-' + beginDay.lMonth + '-' + beginDay.lDay)).format('YYYY-MM-DD');
            var endDayResult = 'L' + (endDay.isLeap ? 'R' : '') + __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(endDay.lYear + '-' + endDay.lMonth + '-' + endDay.lDay)).format('YYYY-MM-DD');

            this.$emit('change', [beginDayResult, endDayResult]);
            this.$emit('input', [beginDayResult, endDayResult]);
          } else {
            //由农历到公历
            //判断日期结果集中日期格式是否为农历，若不是不作处理直接返回。
            if (this.value[0].indexOf('L') == -1) return;
            var _beginDay = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getSolar(this.value[0]);
            var _endDay = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getSolar(this.value[1]);
            var _beginDayResult = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(_beginDay.cYear + '-' + _beginDay.cMonth + '-' + _beginDay.cDay)).format('YYYY-MM-DD');
            var _endDayResult = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(_endDay.cYear + '-' + _endDay.cMonth + '-' + _endDay.cDay)).format('YYYY-MM-DD');

            this.$emit('change', [_beginDayResult, _endDayResult]);
            this.$emit('input', [_beginDayResult, _endDayResult]);
          }
        } else {
          //单日期模式
          var day = void 0,
              result = '';
          if (this.isLunar) {
            //由公历到农历
            //判断日期结果中日期格式是否为农历，若是不作处理直接返回。
            if (this.value.indexOf('L') > -1) return;
            day = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getLunar(this.value.replace(/L/, '').replace(/R/, ''));
            result = 'L' + (day.isLeap ? 'R' : '') + __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(day.lYear + '-' + day.lMonth + '-' + day.lDay)).format('YYYY-MM-DD');
            this.$emit('change', result);
            this.$emit('input', result);
          } else {
            //由农历到公历
            //判断日期结果中日期格式是否为农历，若不是不作处理直接返回。
            if (this.value.indexOf('L') == -1) return;
            day = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getSolar(this.value);
            result = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(day.cYear + '-' + day.cMonth + '-' + day.cDay)).format('YYYY-MM-DD');
            this.$emit('change', new Date(result));
            this.$emit('input', new Date(result));
          }
        }
      }
    },
    showYearList: function showYearList() {
      //公式：A ＝ 默认当前年所在页面的起始年；S ＝ 选择日期所在年份；Z(pagesize) = 12; Math.ceil : 向上入，有小数就向上＋1；
      // result = A - Math.ceil( (A-S) / Z ) * Z;
      var A = this.todayYear + parseInt(this.showBackYears) - 11;
      this.startYear = A - Math.ceil((A - this.year) / 12) * 12;

      this.yearVisible = true;
    },
    goYearPrevList: function goYearPrevList() {
      if (this.startYear < 1912) return;
      this.startYear -= 12;
    },
    goYearNextList: function goYearNextList() {
      if (this.startYear >= this.todayYear + parseInt(this.showBackYears) - 11) return;
      this.startYear += 12;
    },
    goYearPrev: function goYearPrev() {
      this.monthDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).subtract(1, 'years').toISOString();
      this.loadCalendar();
    },
    goYearNext: function goYearNext() {
      this.monthDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).add(1, 'years').toISOString();
      this.loadCalendar();
    },
    goPrev: function goPrev() {
      var newMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).subtract(1, 'months');
      this.monthDay = newMonth.toISOString();
      this.loadCalendar();
    },
    goNext: function goNext() {
      var newMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).add(1, 'months');
      this.monthDay = newMonth.toISOString();
      this.loadCalendar();
    },
    onMouseOver: function onMouseOver(day) {
      if (this.selectDay.length == 1) {
        var currDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()(day.date);
        var beginDt = this.selectDay[0];
        if (currDay.isAfter(beginDt)) {
          this.chooseDay = [beginDt, currDay.toISOString()];
        }
      }
    },
    onMouseOut: function onMouseOut() {
      if (this.selectDay.length < 2) {
        this.chooseDay = [];
      }
    },
    onDateSelect: function onDateSelect(day) {
      if (this.isNotOptional(day)) return;
      var dayDate = new Date(day.date).toISOString();
      if (this.type.toUpperCase() == 'DATERANGE') {
        if (this.selectDay.length >= 2) {
          this.selectDay = [];
          this.chooseDay = [];
        }
        //判断日期；1、第一次选中，直接加入结果集为时间段起始日期；
        // 2、小于起始日期，则重置结果集，所选日期为结果集起始日期；
        // 3、大于等于起始日期，加入结果集为时间段结束日期；可返回结果。
        if (this.selectDay.length > 0) {
          if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(dayDate).isSameOrAfter(this.selectDay[0])) {
            this.selectDay.push(dayDate);
          } else {
            this.selectDay = [dayDate];
          }
        } else {
          this.selectDay.push(dayDate);
        }
        //校正日历控件展示月份到起始月份或当前月份
        //this.monthDay = new Date(this.selectDay[0]).toISOString();
        //判断结果集是否符合条件，数组selectDay.length＝＝2；返回结果；隐藏控件；
        if (this.selectDay.length == 2) {
          if (this.isLunar) {
            var beginLunarDateResult = '',
                endLunarDateResult = '';
            var beginLunar = __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getLunar(this.selectDay[0]);
            beginLunarDateResult = 'L' + (beginLunar.isLeap ? 'R' : '') + __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(beginLunar.lYear + '-' + beginLunar.lMonth + '-' + beginLunar.lDay)).format("YYYY-MM-DD");
            endLunarDateResult = 'L' + (day.lDate.isLeap ? 'R' : '') + __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(day.lDate.lYear + '-' + day.lDate.lMonth + '-' + day.lDate.lDay)).format("YYYY-MM-DD");
            this.$emit('change', [beginLunarDateResult, endLunarDateResult]);
            this.$emit('input', [beginLunarDateResult, endLunarDateResult]);
          } else {
            this.$emit('change', [__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectDay[0]).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectDay[1]).format('YYYY-MM-DD')]);
            this.$emit('input', [__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectDay[0]).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.selectDay[1]).format('YYYY-MM-DD')]);
          }
          this.calendarVisible = false;
        }
      } else {
        var result = day.date;
        if (this.isLunar) {
          var tip = 'L' + (day.lDate.isLeap ? 'R' : '');
          var date = new Date(day.lDate.lYear + '-' + day.lDate.lMonth + '-' + day.lDate.lDay).toISOString();
          result = tip + __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("YYYY-MM-DD");
        }
        this.monthDay = dayDate;
        this.calendarVisible = false;
        this.$emit('change', result);
        this.$emit('input', result);
      }
    },
    onMonthSelect: function onMonthSelect(command) {
      var newMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).month(command);
      this.monthDay = newMonth.toISOString();
      this.loadCalendar();
      this.monthVisible = false;
    },
    onYearSelect: function onYearSelect(command) {
      var newMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).year(command);
      this.monthDay = newMonth.toISOString();
      this.yearVisible = false;
      this.monthVisible = true;
    },
    loadCalendar: function loadCalendar() {
      if (this.monthDay == null || this.monthDay == '') {
        this.monthDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()().toISOString();
      }

      var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.monthDay).startOf('month').format('YYYY-MM-DD');
      var currentMonth = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      this.year = currentMonth.year();
      this.month = currentMonth.month() + 1;
      this.calendarDatas = this.handleCalendar(currentMonth);

      if (this.type.toUpperCase() == 'DATERANGE') {
        //时间段模式
        var currentMonth2 = currentMonth.clone().add(1, 'months');
        this.year2 = currentMonth2.year();
        this.month2 = currentMonth2.month() + 1;
        this.calendarDatas2 = this.handleCalendar(currentMonth2);
      }
    },
    handleCalendar: function handleCalendar(currentMonth) {

      var start = currentMonth.clone();
      start.subtract(start.day(), 'd');
      var calendars = [];

      for (var iWeek = 0; iWeek < 6; iWeek++) {
        var week = [];
        if (iWeek > 0 && !start.isSame(currentMonth, 'month')) {
          break;
        }
        for (var iDay = 0; iDay < 7; iDay++) {
          week.push({
            day: start.date(),
            isToday: start.isSame(new Date(), 'day'),
            isSelect: this.selectDay.length > 0 && start.isSame(new Date(this.selectDay[0]), 'day'),
            isCurMonth: start.isSame(currentMonth, 'month'),
            weekIndex: iWeek,
            week: iDay,
            date: start.clone().format('YYYY-MM-DD'),
            lDate: __WEBPACK_IMPORTED_MODULE_2__jDatePicker_js__["a" /* default */].calendar.getLunar(start.toISOString())
          });
          start.add(1, 'd');
        }
        calendars.push(week);
      }

      return calendars;
    }
  }

});

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @1900-2100区间内的公历、农历互转
 * @charset UTF-8
 * @公历转农历：calendar.solar2lunar(1987,11,01); //[you can ignore params of prefix 0]
 */
var calendar = {

  /**
   * 农历1900-2100的润大小信息表
   * @Array Of Property
   * @return Hex
   */
  lunarInfo: [0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2, //1900-1909
  0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977, //1910-1919
  0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970, //1920-1929
  0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950, //1930-1939
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557, //1940-1949
  0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5b0, 0x14573, 0x052b0, 0x0a9a8, 0x0e950, 0x06aa0, //1950-1959
  0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0, //1960-1969
  0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b6a0, 0x195a6, //1970-1979
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570, //1980-1989
  0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0, //1990-1999
  0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5, //2000-2009
  0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930, //2010-2019
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530, //2020-2029
  0x05aa0, 0x076a3, 0x096d0, 0x04afb, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45, //2030-2039
  0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0, //2040-2049
  /**Add By JJonline@JJonline.Cn**/
  0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0, //2050-2059
  0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4, //2060-2069
  0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0, //2070-2079
  0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160, //2080-2089
  0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150, 0x0f252, //2090-2099
  0x0d520], //2100

  /**
   * 公历每个月份的天数普通表
   * @Array Of Property
   * @return Number
   */
  solarMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

  /**
   * 天干地支之天干速查表
   * @Array Of Property trans["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"]
   * @return Cn string
   */
  Gan: ["\u7532", "\u4E59", "\u4E19", "\u4E01", "\u620A", "\u5DF1", "\u5E9A", "\u8F9B", "\u58EC", "\u7678"],

  /**
   * 天干地支之地支速查表
   * @Array Of Property
   * @trans["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"]
   * @return Cn string
   */
  Zhi: ["\u5B50", "\u4E11", "\u5BC5", "\u536F", "\u8FB0", "\u5DF3", "\u5348", "\u672A", "\u7533", "\u9149", "\u620C", "\u4EA5"],

  /**
   * 天干地支之地支速查表<=>生肖
   * @Array Of Property
   * @trans["鼠","牛","虎","兔","龙","蛇","马","羊","猴","鸡","狗","猪"]
   * @return Cn string
   */
  Animals: ["\u9F20", "\u725B", "\u864E", "\u5154", "\u9F99", "\u86C7", "\u9A6C", "\u7F8A", "\u7334", "\u9E21", "\u72D7", "\u732A"],

  /**
   * 24节气速查表
   * @Array Of Property
   * @trans["小寒","大寒","立春","雨水","惊蛰","春分","清明","谷雨","立夏","小满","芒种","夏至","小暑","大暑","立秋","处暑","白露","秋分","寒露","霜降","立冬","小雪","大雪","冬至"]
   * @return Cn string
   */
  solarTerm: ["\u5C0F\u5BD2", "\u5927\u5BD2", "\u7ACB\u6625", "\u96E8\u6C34", "\u60CA\u86F0", "\u6625\u5206", "\u6E05\u660E", "\u8C37\u96E8", "\u7ACB\u590F", "\u5C0F\u6EE1", "\u8292\u79CD", "\u590F\u81F3", "\u5C0F\u6691", "\u5927\u6691", "\u7ACB\u79CB", "\u5904\u6691", "\u767D\u9732", "\u79CB\u5206", "\u5BD2\u9732", "\u971C\u964D", "\u7ACB\u51AC", "\u5C0F\u96EA", "\u5927\u96EA", "\u51AC\u81F3"],

  /**
   * 1900-2100各年的24节气日期速查表
   * @Array Of Property
   * @return 0x string For splice
   */
  sTermInfo: ['9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c3598082c95f8c965cc920f', '97bd0b06bdb0722c965ce1cfcc920f', 'b027097bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c359801ec95f8c965cc920f', '97bd0b06bdb0722c965ce1cfcc920f', 'b027097bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c359801ec95f8c965cc920f', '97bd0b06bdb0722c965ce1cfcc920f', 'b027097bd097c36b0b6fc9274c91aa', '9778397bd19801ec9210c965cc920e', '97b6b97bd19801ec95f8c965cc920f', '97bd09801d98082c95f8e1cfcc920f', '97bd097bd097c36b0b6fc9210c8dc2', '9778397bd197c36c9210c9274c91aa', '97b6b97bd19801ec95f8c965cc920e', '97bd09801d98082c95f8e1cfcc920f', '97bd097bd097c36b0b6fc9210c8dc2', '9778397bd097c36c9210c9274c91aa', '97b6b97bd19801ec95f8c965cc920e', '97bcf97c3598082c95f8e1cfcc920f', '97bd097bd097c36b0b6fc9210c8dc2', '9778397bd097c36c9210c9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c3598082c95f8c965cc920f', '97bd097bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c3598082c95f8c965cc920f', '97bd097bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c359801ec95f8c965cc920f', '97bd097bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c359801ec95f8c965cc920f', '97bd097bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf97c359801ec95f8c965cc920f', '97bd097bd07f595b0b6fc920fb0722', '9778397bd097c36b0b6fc9210c8dc2', '9778397bd19801ec9210c9274c920e', '97b6b97bd19801ec95f8c965cc920f', '97bd07f5307f595b0b0bc920fb0722', '7f0e397bd097c36b0b6fc9210c8dc2', '9778397bd097c36c9210c9274c920e', '97b6b97bd19801ec95f8c965cc920f', '97bd07f5307f595b0b0bc920fb0722', '7f0e397bd097c36b0b6fc9210c8dc2', '9778397bd097c36c9210c9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bd07f1487f595b0b0bc920fb0722', '7f0e397bd097c36b0b6fc9210c8dc2', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf7f1487f595b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf7f1487f595b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf7f1487f531b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c965cc920e', '97bcf7f1487f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b97bd19801ec9210c9274c920e', '97bcf7f0e47f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '9778397bd097c36b0b6fc9210c91aa', '97b6b97bd197c36c9210c9274c920e', '97bcf7f0e47f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '9778397bd097c36b0b6fc9210c8dc2', '9778397bd097c36c9210c9274c920e', '97b6b7f0e47f531b0723b0b6fb0722', '7f0e37f5307f595b0b0bc920fb0722', '7f0e397bd097c36b0b6fc9210c8dc2', '9778397bd097c36b0b70c9274c91aa', '97b6b7f0e47f531b0723b0b6fb0721', '7f0e37f1487f595b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc9210c8dc2', '9778397bd097c36b0b6fc9274c91aa', '97b6b7f0e47f531b0723b0b6fb0721', '7f0e27f1487f595b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '9778397bd097c36b0b6fc9274c91aa', '97b6b7f0e47f531b0723b0787b0721', '7f0e27f0e47f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '9778397bd097c36b0b6fc9210c91aa', '97b6b7f0e47f149b0723b0787b0721', '7f0e27f0e47f531b0723b0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '9778397bd097c36b0b6fc9210c8dc2', '977837f0e37f149b0723b0787b0721', '7f07e7f0e47f531b0723b0b6fb0722', '7f0e37f5307f595b0b0bc920fb0722', '7f0e397bd097c35b0b6fc9210c8dc2', '977837f0e37f14998082b0787b0721', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e37f1487f595b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc9210c8dc2', '977837f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '977837f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd097c35b0b6fc920fb0722', '977837f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '977837f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '977837f0e37f14998082b0787b06bd', '7f07e7f0e47f149b0723b0787b0721', '7f0e27f0e47f531b0b0bb0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '977837f0e37f14998082b0723b06bd', '7f07e7f0e37f149b0723b0787b0721', '7f0e27f0e47f531b0723b0b6fb0722', '7f0e397bd07f595b0b0bc920fb0722', '977837f0e37f14898082b0723b02d5', '7ec967f0e37f14998082b0787b0721', '7f07e7f0e47f531b0723b0b6fb0722', '7f0e37f1487f595b0b0bb0b6fb0722', '7f0e37f0e37f14898082b0723b02d5', '7ec967f0e37f14998082b0787b0721', '7f07e7f0e47f531b0723b0b6fb0722', '7f0e37f1487f531b0b0bb0b6fb0722', '7f0e37f0e37f14898082b0723b02d5', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e37f1487f531b0b0bb0b6fb0722', '7f0e37f0e37f14898082b072297c35', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e37f0e37f14898082b072297c35', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e37f0e366aa89801eb072297c35', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f149b0723b0787b0721', '7f0e27f1487f531b0b0bb0b6fb0722', '7f0e37f0e366aa89801eb072297c35', '7ec967f0e37f14998082b0723b06bd', '7f07e7f0e47f149b0723b0787b0721', '7f0e27f0e47f531b0723b0b6fb0722', '7f0e37f0e366aa89801eb072297c35', '7ec967f0e37f14998082b0723b06bd', '7f07e7f0e37f14998083b0787b0721', '7f0e27f0e47f531b0723b0b6fb0722', '7f0e37f0e366aa89801eb072297c35', '7ec967f0e37f14898082b0723b02d5', '7f07e7f0e37f14998082b0787b0721', '7f07e7f0e47f531b0723b0b6fb0722', '7f0e36665b66aa89801e9808297c35', '665f67f0e37f14898082b0723b02d5', '7ec967f0e37f14998082b0787b0721', '7f07e7f0e47f531b0723b0b6fb0722', '7f0e36665b66a449801e9808297c35', '665f67f0e37f14898082b0723b02d5', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e36665b66a449801e9808297c35', '665f67f0e37f14898082b072297c35', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e26665b66a449801e9808297c35', '665f67f0e37f1489801eb072297c35', '7ec967f0e37f14998082b0787b06bd', '7f07e7f0e47f531b0723b0b6fb0721', '7f0e27f1487f531b0b0bb0b6fb0722'],

  /**
   * 数字转中文速查表
   * @Array Of Property
   * @trans ['日','一','二','三','四','五','六','七','八','九','十']
   * @return Cn string
   */
  nStr1: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341"],

  /**
   * 日期转农历称呼速查表
   * @Array Of Property
   * @trans ['初','十','廿','卅']
   * @return Cn string
   */
  nStr2: ["\u521D", "\u5341", "\u5EFF", "\u5345"],

  /**
   * 月份转农历称呼速查表
   * @Array Of Property
   * @trans ['正','一','二','三','四','五','六','七','八','九','十','冬','腊']
   * @return Cn string
   */
  nStr3: ["\u6B63", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u51AC", "\u814A"],

  /**
   * 返回农历y年一整年的总天数
   * @param lunar Year
   * @return Number
   * @eg:var count = calendar.lYearDays(1987) ;//count=387
   */
  lYearDays: function lYearDays(y) {
    var i,
        sum = 348;
    for (i = 0x8000; i > 0x8; i >>= 1) {
      sum += calendar.lunarInfo[y - 1900] & i ? 1 : 0;
    }
    return sum + calendar.leapDays(y);
  },

  /**
   * 返回农历y年闰月是哪个月；若y年没有闰月 则返回0
   * @param lunar Year
   * @return Number (0-12)
   * @eg:var leapMonth = calendar.leapMonth(1987) ;//leapMonth=6
   */
  leapMonth: function leapMonth(y) {
    //闰字编码 \u95f0
    return calendar.lunarInfo[y - 1900] & 0xf;
  },

  /**
   * 返回农历y年闰月的天数 若该年没有闰月则返回0
   * @param lunar Year
   * @return Number (0、29、30)
   * @eg:var leapMonthDay = calendar.leapDays(1987) ;//leapMonthDay=29
   */
  leapDays: function leapDays(y) {
    if (calendar.leapMonth(y)) {
      return calendar.lunarInfo[y - 1900] & 0x10000 ? 30 : 29;
    }
    return 0;
  },

  /**
   * 返回农历y年m月（非闰月）的总天数，计算m为闰月时的天数请使用leapDays方法
   * @param lunar Year
   * @return Number (-1、29、30)
   * @eg:var MonthDay = calendar.monthDays(1987,9) ;//MonthDay=29
   */
  monthDays: function monthDays(y, m) {
    if (m > 12 || m < 1) {
      return -1;
    } //月份参数从1至12，参数错误返回-1
    return calendar.lunarInfo[y - 1900] & 0x10000 >> m ? 30 : 29;
  },

  /**
   * 返回公历(!)y年m月的天数
   * @param solar Year
   * @return Number (-1、28、29、30、31)
   * @eg:var solarMonthDay = calendar.leapDays(1987) ;//solarMonthDay=30
   */
  solarDays: function solarDays(y, m) {
    if (m > 12 || m < 1) {
      return -1;
    } //若参数错误 返回-1
    var ms = m - 1;
    if (ms == 1) {
      //2月份的闰平规律测算后确认返回28或29
      return y % 4 == 0 && y % 100 != 0 || y % 400 == 0 ? 29 : 28;
    } else {
      return calendar.solarMonth[ms];
    }
  },

  /**
   * 农历年份转换为干支纪年
   * @param  lYear 农历年的年份数
   * @return Cn string
   */
  toGanZhiYear: function toGanZhiYear(lYear) {
    var ganKey = (lYear - 3) % 10;
    var zhiKey = (lYear - 3) % 12;
    if (ganKey == 0) ganKey = 10; //如果余数为0则为最后一个天干
    if (zhiKey == 0) zhiKey = 12; //如果余数为0则为最后一个地支
    return calendar.Gan[ganKey - 1] + calendar.Zhi[zhiKey - 1];
  },

  /**
   * 公历月、日判断所属星座
   * @param  cMonth [description]
   * @param  cDay [description]
   * @return Cn string
   */
  toAstro: function toAstro(cMonth, cDay) {
    var s = "\u9B54\u7FAF\u6C34\u74F6\u53CC\u9C7C\u767D\u7F8A\u91D1\u725B\u53CC\u5B50\u5DE8\u87F9\u72EE\u5B50\u5904\u5973\u5929\u79E4\u5929\u874E\u5C04\u624B\u9B54\u7FAF";
    var arr = [20, 19, 21, 21, 21, 22, 23, 23, 23, 23, 22, 22];
    return s.substr(cMonth * 2 - (cDay < arr[cMonth - 1] ? 2 : 0), 2) + "\u5EA7"; //座
  },

  /**
   * 传入offset偏移量返回干支
   * @param offset 相对甲子的偏移量
   * @return Cn string
   */
  toGanZhi: function toGanZhi(offset) {
    return calendar.Gan[offset % 10] + calendar.Zhi[offset % 12];
  },

  /**
   * 传入公历(!)y年获得该年第n个节气的公历日期
   * @param y公历年(1900-2100)；n二十四节气中的第几个节气(1~24)；从n=1(小寒)算起
   * @return day Number
   * @eg:var _24 = calendar.getTerm(1987,3) ;//_24=4;意即1987年2月4日立春
   */
  getTerm: function getTerm(y, n) {
    if (y < 1900 || y > 2100) {
      return -1;
    }
    if (n < 1 || n > 24) {
      return -1;
    }
    var _table = calendar.sTermInfo[y - 1900];
    var _info = [parseInt('0x' + _table.substr(0, 5)).toString(), parseInt('0x' + _table.substr(5, 5)).toString(), parseInt('0x' + _table.substr(10, 5)).toString(), parseInt('0x' + _table.substr(15, 5)).toString(), parseInt('0x' + _table.substr(20, 5)).toString(), parseInt('0x' + _table.substr(25, 5)).toString()];
    var _calday = [_info[0].substr(0, 1), _info[0].substr(1, 2), _info[0].substr(3, 1), _info[0].substr(4, 2), _info[1].substr(0, 1), _info[1].substr(1, 2), _info[1].substr(3, 1), _info[1].substr(4, 2), _info[2].substr(0, 1), _info[2].substr(1, 2), _info[2].substr(3, 1), _info[2].substr(4, 2), _info[3].substr(0, 1), _info[3].substr(1, 2), _info[3].substr(3, 1), _info[3].substr(4, 2), _info[4].substr(0, 1), _info[4].substr(1, 2), _info[4].substr(3, 1), _info[4].substr(4, 2), _info[5].substr(0, 1), _info[5].substr(1, 2), _info[5].substr(3, 1), _info[5].substr(4, 2)];
    return parseInt(_calday[n - 1]);
  },

  /**
   * 传入农历数字月份返回汉语通俗表示法
   * @param lunar month
   * @return Cn string
   * @eg:var cnMonth = calendar.toChinaMonth(12) ;//cnMonth='腊月'
   */
  toChinaMonth: function toChinaMonth(m) {
    // 月 => \u6708
    if (m > 12 || m < 1) {
      return -1;
    } //若参数错误 返回-1
    var s = calendar.nStr3[m - 1];
    s += "\u6708"; //加上月字
    return s;
  },

  /**
   * 传入年份月份返回第n个星期日的日期数字
   * @param y 年份
   * @param m 月份
   * @param n 第几个星期日 ( 5>n>0的数字 一个月一般就4个星期日，最多5个)
   * @return 日期数字；3 ＝ getSunday(2017,9,1); 九月的第一个星期日是3号；超出返回-1
   */
  getSunday: function getSunday(y, m, n) {
    var d = new Date(y + '-' + m + '-1');
    var d2 = new Date(y + '-' + (m + 1) + '-1');
    d2.setDate(0);
    var maxDay = d2.getDate(); //传入月份的最后一天

    var week = d.getDay();
    var first = 1;
    if (week > 0) first = d.getDate() + (7 - week);
    var result = (n - 1) * 7 + first;
    if (result > maxDay) return -1;
    return result;
  },

  /**
   * 传入农历日期数字返回汉字表示法
   * @param lunar day
   * @return Cn string
   * @eg:var cnDay = calendar.toChinaDay(21) ;//cnMonth='廿一'
   */
  toChinaDay: function toChinaDay(d) {
    //日 => \u65e5
    var s;
    switch (d) {
      case 10:
        s = "\u521D\u5341";break;
      case 20:
        s = "\u4E8C\u5341";break;
        break;
      case 30:
        s = "\u4E09\u5341";break;
        break;
      default:
        s = calendar.nStr2[Math.floor(d / 10)];
        s += calendar.nStr1[d % 10];
    }
    return s;
  },

  /**
   * 年份转生肖[!仅能大致转换] => 精确划分生肖分界线是“立春”
   * @param y year
   * @return Cn string
   * @eg:var animal = calendar.getAnimal(1987) ;//animal='兔'
   */
  getAnimal: function getAnimal(y) {
    return calendar.Animals[(y - 4) % 12];
  },

  /**
   * 传入阳历年月日获得详细的公历、农历object信息 <=>JSON
   * @param y  solar year
   * @param m  solar month
   * @param d  solar day
   * @return JSON object
   * @eg:console.log(calendar.solar2lunar(1987,11,01));
   */
  solar2lunar: function solar2lunar(y, m, d) {
    //参数区间1900.1.31~2100.12.31
    //年份限定、上限
    if (y < 1900 || y > 2100) {
      return -1; // undefined转换为数字变为NaN
    }
    //公历传参最下限
    if (y == 1900 && m == 1 && d < 31) {
      return -1;
    }
    //未传参  获得当天
    if (!y) {
      var objDate = new Date();
    } else {
      var objDate = new Date(y, parseInt(m) - 1, d);
    }
    var i,
        leap = 0,
        temp = 0;
    //修正ymd参数
    var y = objDate.getFullYear(),
        m = objDate.getMonth() + 1,
        d = objDate.getDate();
    var offset = (Date.UTC(objDate.getFullYear(), objDate.getMonth(), objDate.getDate()) - Date.UTC(1900, 0, 31)) / 86400000;
    for (i = 1900; i < 2101 && offset > 0; i++) {
      temp = calendar.lYearDays(i);
      offset -= temp;
    }
    if (offset < 0) {
      offset += temp;i--;
    }

    //是否今天
    var isTodayObj = new Date(),
        isToday = false;
    if (isTodayObj.getFullYear() == y && isTodayObj.getMonth() + 1 == m && isTodayObj.getDate() == d) {
      isToday = true;
    }
    //星期几
    var nWeek = objDate.getDay(),
        cWeek = calendar.nStr1[nWeek];
    //数字表示周几顺应天朝周一开始的惯例
    if (nWeek == 0) {
      nWeek = 7;
    }
    //农历年
    var year = i;
    var leap = calendar.leapMonth(i); //闰哪个月
    var isLeap = false;

    //效验闰月
    for (i = 1; i < 13 && offset > 0; i++) {
      //闰月
      if (leap > 0 && i == leap + 1 && isLeap == false) {
        --i;
        isLeap = true;temp = calendar.leapDays(year); //计算农历闰月天数
      } else {
        temp = calendar.monthDays(year, i); //计算农历普通月天数
      }
      //解除闰月
      if (isLeap == true && i == leap + 1) {
        isLeap = false;
      }
      offset -= temp;
    }
    // 闰月导致数组下标重叠取反
    if (offset == 0 && leap > 0 && i == leap + 1) {
      if (isLeap) {
        isLeap = false;
      } else {
        isLeap = true;--i;
      }
    }
    if (offset < 0) {
      offset += temp;--i;
    }
    //农历月
    var month = i;
    //农历日
    var day = offset + 1;
    //天干地支处理
    var sm = m - 1;
    var gzY = calendar.toGanZhiYear(year);

    // 当月的两个节气
    // bugfix-2017-7-24 11:03:38 use lunar Year Param `y` Not `year`
    var firstNode = calendar.getTerm(y, m * 2 - 1); //返回当月「节」为几日开始
    var secondNode = calendar.getTerm(y, m * 2); //返回当月「节」为几日开始

    // 依据12节气修正干支月
    var gzM = calendar.toGanZhi((y - 1900) * 12 + m + 11);
    if (d >= firstNode) {
      gzM = calendar.toGanZhi((y - 1900) * 12 + m + 12);
    }

    //传入的日期的节气与否
    var isTerm = false;
    var Term = null;
    if (firstNode == d) {
      isTerm = true;
      Term = calendar.solarTerm[m * 2 - 2];
    }
    if (secondNode == d) {
      isTerm = true;
      Term = calendar.solarTerm[m * 2 - 1];
    }
    //日柱 当月一日与 1900/1/1 相差天数
    var dayCyclical = Date.UTC(y, sm, 1, 0, 0, 0, 0) / 86400000 + 25567 + 10;
    var gzD = calendar.toGanZhi(dayCyclical + d - 1);
    //该日期所属的星座
    var astro = calendar.toAstro(m, d);
    //该日期所有的节日
    var festival = [];
    //农历传统节日
    if (month == 1 && day == 1) {
      festival.push('春节');
    } else if (month == 1 && day == 15) {
      festival.push('上元节');
    } else if (month == 2 && day == 2) {
      festival.push('龙抬头');
    } else if (month == 5 && day == 5) {
      festival.push('端午');
    } else if (month == 7) {
      if (day == 7) festival.push('七夕');
      if (day == 15) festival.push('中元节');
    } else if (month == 8 && day == 15) {
      festival.push('中秋');
    } else if (month == 9 && day == 9) {
      festival.push('重阳');
    } else if (month == 10 && day == 15) {
      festival.push('下元节');
    } else if (month == 12) {
      if (day == 8) festival.push('腊八');
      if (day == 23) festival.push('小年');
      if (isLeap ? day == calendar.leapDays(year) : calendar.monthDays(month - 1) == 29 ? day == 30 : day == 29) festival.push('除夕');
    }
    //公历节日
    if (m == 1 && d == 1) {
      festival.splice(0, 0, '元旦');
    } else if (m == 2 && d == 14) {
      festival.push('情人节');
    } else if (m == 3) {
      if (d == 8) festival.push('妇女节');
      if (d == 12) festival.push('植树节');
    } else if (m == 4 && d == 1) {
      festival.push('愚人节');
    } else if (m == 5) {
      if (d == 1) festival.push('劳动节');
      if (d == 4) festival.push('青年节');
      if (d == calendar.getSunday(y, m, 2)) festival.push('母亲节');
    } else if (m == 6) {
      if (d == 1) festival.push('儿童节');
      if (d == 4) festival.push('青年节');
      if (d == calendar.getSunday(y, m, 3)) festival.push('父亲节');
    } else if (m == 7 && d == 1) {
      festival.push('建党节');
    } else if (m == 8 && d == 1) {
      festival.push('建军节');
    } else if (m == 9 && d == 10) {
      festival.push('教师节');
    } else if (m == 10 && d == 1) {
      festival.push('国庆节');
    } else if (m == 11 && d == 1) {
      festival.push('万圣节');
    } else if (m == 12) {
      if (d == 24) festival.push('平安夜');
      if (d == 25) festival.push('圣诞节');
    }
    return { 'lYear': year, 'lMonth': month, 'lDay': day, 'isFestival': festival.length > 0, 'festival': festival, 'Animal': calendar.getAnimal(year), 'IMonthCn': (isLeap ? "\u95F0" : '') + calendar.toChinaMonth(month), 'IDayCn': calendar.toChinaDay(day), 'cYear': y, 'cMonth': m, 'cDay': d, 'gzYear': gzY, 'gzMonth': gzM, 'gzDay': gzD, 'isToday': isToday, 'isLeap': isLeap, 'nWeek': nWeek, 'ncWeek': "\u661F\u671F" + cWeek, 'isTerm': isTerm, 'Term': Term, 'astro': astro };
  },

  getLunar: function getLunar(date) {
    var D;
    if (date == undefined) {
      D = new Date();
    } else {
      D = new Date(date);
    }
    D.setHours(D.getHours() + 8); //根据国际UTC标准，中国时区应为：UTC+8
    var cY = D.getUTCFullYear();
    var cM = D.getUTCMonth() + 1;
    var cD = D.getUTCDate();
    //console.log('getLunar:月'+cM+'--'+cD+'日')
    return calendar.solar2lunar(cY, cM, cD);
  },

  /**
   * 传入农历年月日以及传入的月份是否闰月获得详细的公历、农历object信息 <=>JSON
   * @param y  lunar year
   * @param m  lunar month
   * @param d  lunar day
   * @param isLeapMonth  lunar month is leap or not.[如果是农历闰月第四个参数赋值true即可]
   * @return JSON object
   * @eg:console.log(calendar.lunar2solar(1987,9,10));
   */
  lunar2solar: function lunar2solar(y, m, d, isLeapMonth) {
    //参数区间1900.1.31~2100.12.1
    var isLeapMonth = !!isLeapMonth;
    var leapOffset = 0;
    var leapMonth = calendar.leapMonth(y);
    var leapDay = calendar.leapDays(y);
    if (isLeapMonth && leapMonth != m) {
      return -1;
    } //传参要求计算该闰月公历 但该年得出的闰月与传参的月份并不同
    if (y == 2100 && m == 12 && d > 1 || y == 1900 && m == 1 && d < 31) {
      return -1;
    } //超出了最大极限值
    var day = calendar.monthDays(y, m);
    var _day = day;
    //bugFix 2016-9-25
    //if month is leap, _day use leapDays method
    if (isLeapMonth) {
      _day = calendar.leapDays(y, m);
    }
    if (y < 1900 || y > 2100 || d > _day) {
      return -1;
    } //参数合法性效验

    //计算农历的时间差
    var offset = 0;
    for (var i = 1900; i < y; i++) {
      offset += calendar.lYearDays(i);
    }
    var leap = 0,
        isAdd = false;
    for (var i = 1; i < m; i++) {
      leap = calendar.leapMonth(y);
      if (!isAdd) {
        //处理闰月
        if (leap <= i && leap > 0) {
          offset += calendar.leapDays(y);isAdd = true;
        }
      }
      offset += calendar.monthDays(y, i);
    }
    //转换闰月农历 需补充该年闰月的前一个月的时差
    if (isLeapMonth) {
      offset += day;
    }
    //1900年农历正月一日的公历时间为1900年1月30日0时0分0秒(该时间也是本农历的最开始起始点)
    var stmap = Date.UTC(1900, 1, 30, 0, 0, 0);
    var calObj = new Date((offset + d - 31) * 86400000 + stmap);
    var cY = calObj.getUTCFullYear();
    var cM = calObj.getUTCMonth() + 1;
    var cD = calObj.getUTCDate();

    return calendar.solar2lunar(cY, cM, cD);
  },
  /**
   * 传入农历日期
   * @param date 类型String，格式：L2017-01-02；闰月：LR2017-06-03
   * @returns {*|JSON}
   */
  getSolar: function getSolar(date) {
    if (date == undefined || date == null || date == '' || date.indexOf('L') == -1) return null;
    var isLeapMonth = date.indexOf('R') > -1;
    var D = date.replace(/L/, '').replace(/R/, '').split('-');
    var cY = parseInt(D[0]);
    var cM = parseInt(D[1]);
    var cD = parseInt(D[2]);
    return calendar.lunar2solar(cY, cM, cD, isLeapMonth);
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({ calendar: calendar });

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(117);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

// import Vue from 'vue'
// import App from './App'


// import vuePayKeyboard from './lib/indexvue-pay-keyboard'


// import VueJLunarDatePicker from './components/index.js'
// Vue.use(VueJLunarDatePicker)
// import VueJLunarDatePicker from '@/components/JDatePicker.vue'
// export default VueJLunarDatePicker;

/***/ })

},[131]);
});


// WEBPACK FOOTER //
// static/js/app.5f992a4a20305e810300.js